import moment from "moment";

const dateFormatter = (value) => {
  if (!value) return "";
  return moment(value).format("MM-DD-YYYY");
};

export const Signal_No_schema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Signal Number", colSpan: 8, rowSpan: 1, accessor: "assetName" }],
  },
];
export const TripStopHeader = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Test Description", colSpan: 3, rowSpan: 1, isTitleOnly: true },
      { title: "Date", colSpan: 1, rowSpan: 1, isTitleOnly: true },
      { title: "Condition", colSpan: 1, rowSpan: 1, isTitleOnly: true },
      { title: "Comments", colSpan: 3, rowSpan: 1, isTitleOnly: true },
    ],
  },
];

export const TripStopSchemaGauge = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Gauge", colSpan: 3, rowSpan: 1, leftAlign: true, accessor: "test", isTitleOnly: true },
      { title: "Date Tested", colSpan: 1, rowSpan: 1, accessor: "date", isValueOnly: true, formatter: dateFormatter },
      { title: "Condition", colSpan: 1, rowSpan: 1, accessor: "test", isValueOnly: true },
      { title: "Comments", colSpan: 3, rowSpan: 1, accessor: "com", isValueOnly: true },
    ],
  },
];
export const six_month_schema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Six Month Inspection", colSpan: 3, rowSpan: 1, leftAlign: true, isTitleOnly: true },
      { title: "Date Tested", colSpan: 1, rowSpan: 1, accessor: "date", isValueOnly: true, formatter: dateFormatter },
      { title: "Condition", colSpan: 1, rowSpan: 1, accessor: "test", isValueOnly: true },
      { title: "Comments", colSpan: 3, rowSpan: 1, accessor: "com", isValueOnly: true },
    ],
  },
];

export const circuit_controller_schema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,
    columns: [
      { title: "Circuit Controller", colSpan: 3, rowSpan: 1, leftAlign: true, isTitleOnly: true },
      { title: "Date Tested", colSpan: 1, rowSpan: 1, accessor: "date", isValueOnly: true, formatter: dateFormatter },
      { title: "Condition", colSpan: 1, rowSpan: 1, accessor: "test", isValueOnly: true },
      { title: "Comments", colSpan: 3, rowSpan: 1, accessor: "com", isValueOnly: true },
    ],
  },
];
export const Lamp_test_schema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,
    columns: [
      { title: "Lamp Test", colSpan: 3, rowSpan: 1, leftAlign: true, isTitleOnly: true },
      { title: "Date Tested", colSpan: 1, rowSpan: 1, accessor: "date", isValueOnly: true, formatter: dateFormatter },
      { title: "Condition", colSpan: 1, rowSpan: 1, accessor: "test", isValueOnly: true },
      { title: "Comments", colSpan: 3, rowSpan: 1, accessor: "com", isValueOnly: true },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TripStopReport/TripStopSchema.jsx